import { ErrorBoundary as SentryBoundary, type ErrorBoundaryProps as SentryBoundaryProps } from '@sentry/react';

import { ErrorMessage } from '@/components/ErrorMessage';

export type ErrorBoundaryProps = SentryBoundaryProps;

export const ErrorBoundary = (props: ErrorBoundaryProps) => <SentryBoundary fallback={<ErrorMessage />} {...props} />;
